export const RULE_STARTERS = [
  {
    id: 'tag',
    title: 'Leave orders with a tag alone',
    help: 'Protect special orders, such as fragile or manually handled shipments.',
    match: { all: [{ field: 'tag', op: 'has', value: [] }] },
    actions: [{ type: 'skip', reason: 'Excluded by tag' }],
    stopProcessing: true
  },
  {
    id: 'place',
    title: 'Never use a service for a state or ZIP prefix',
    help: 'Keep a service out of a destination where it is not a good fit.',
    match: { all: [{ field: 'state', op: 'eq', value: '' }] },
    actions: [{ type: 'exclude_services', services: [] }]
  },
  {
    id: 'mi',
    title: 'Never use UPS Mail Innovations for heavy or big boxes',
    help: 'Start with over 16 oz or a side over 18 inches; change the limits to suit you.',
    match: {
      any: [
        { field: 'weightOz', op: 'gt', value: 16 },
        { field: 'longestSideIn', op: 'gt', value: 18 }
      ]
    },
    actions: [{ type: 'exclude_groups', groups: ['MI'] }]
  },
  {
    id: 'carriers',
    title: 'Only use certain carriers for a store',
    help: 'Choose a store and the accounts its orders may use.',
    match: { all: [{ field: 'storeId', op: 'eq', value: '' }] },
    actions: [{ type: 'only_carriers', carriers: [] }]
  },
  {
    id: 'prefer',
    title: 'Prefer a service when it is close in price',
    help: 'Start with USPS Ground Advantage within $1; choose your service and limit.',
    actions: [
      {
        type: 'prefer_service',
        serviceCode: 'usps_ground_advantage',
        withinAmount: 1
      }
    ]
  },
  {
    id: 'force',
    title: 'Always use a service for a store',
    help: 'Use the service when it is available and allowed to win.',
    match: { all: [{ field: 'storeId', op: 'eq', value: '' }] },
    actions: [{ type: 'force_service', serviceCode: 'usps_ground_advantage' }]
  },
  {
    id: 'add-tag',
    title: 'Add a tag to orders Rate Shop changes',
    help: 'Label matching orders so they are easy to find in ShipStation.',
    actions: [{ type: 'add_tag', tag: '' }]
  },
  {
    id: 'scratch',
    title: 'Start from scratch',
    help: 'Choose your own conditions and actions.',
    actions: []
  }
];
export function ruleFromStarter(id, priority) {
  const starter =
    RULE_STARTERS.find(s => s.id === id) ||
    RULE_STARTERS[RULE_STARTERS.length - 1];
  return JSON.parse(
    JSON.stringify({
      name: starter.id === 'scratch' ? '' : starter.title,
      priority,
      enabled: true,
      system: false,
      notes: '',
      stopProcessing: Boolean(starter.stopProcessing),
      match: { all: starter.match?.all || [], any: starter.match?.any || [] },
      actions: starter.actions
    })
  );
}
